import type { StyleRule } from '@archipro-design/aria';
import {
    dropdownSlotClassNames,
    pxArrayToRem,
    pxToRem,
} from '@archipro-design/aria';
import { dropdownItemSlotClassNames } from '@fluentui/react-northstar';
import { svgIconClassName } from '@archipro-design/icons';
import { hex2rgba } from '~/utils/colorHelper';

export const OptionPicker: StyleRule = ({ theme }) => ({
    alignItems: 'center',
    columnGap: pxToRem(8),
    borderBottom: `1px solid ${theme.siteVariables.colors.primitive.black}`,
    minHeight: pxToRem(58),
});

export const OptionLabel: StyleRule = ({ theme }) => ({
    fontSize: pxToRem(16),
    lineHeight: theme.siteVariables.lineHeightDefault,
    color: theme.siteVariables.colors.charcoal[250],
});

export const OptionDropdown: StyleRule<{ menuOpen: boolean }> = ({
    theme,
    menuOpen,
}) => ({
    position: 'relative',
    [`& .${dropdownSlotClassNames.container}`]: {
        width: '100%',
        background: 'transparent',
    },
    [`& .${dropdownSlotClassNames.toggleIndicator}`]: {
        top: 0,
        left: pxToRem(6),
        bottom: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        cursor: 'pointer',
        [`& .${svgIconClassName}`]: {
            width: pxToRem(32),
            height: pxToRem(32),
            marginTop: pxToRem(-1),
            lineHeight: theme.siteVariables.lineHeightDefault,
            '& svg': {
                width: '100%',
                height: '100%',
                lineHeight: 'inherit',
                transition: 'transform 150ms',
                transform: menuOpen
                    ? `rotate(59deg) translate(${pxToRem(-2)}, ${pxToRem(1)})`
                    : 'rotate(0deg)',
            },
        },
    },
    [`& .${dropdownSlotClassNames.triggerButton}`]: {
        position: 'static',
        fontSize: pxToRem(16),
        background: 'transparent',
        paddingLeft: pxToRem(55),
        minHeight: pxToRem(56),
        letterSpacing: theme.siteVariables.letterSpacingMedium,
        lineHeight: theme.siteVariables.lineHeightMedium,
        '&:hover': {
            color: theme.siteVariables.colors.charcoal[250],
            backgroundColor: hex2rgba(
                theme.siteVariables.colors.charcoal[250]!,
                0.06
            ),
        },
        '&:focus': {
            outline: 'none',
        },
        '& span': {
            display: 'block',
            maxWidth: pxToRem(408),
            textOverflow: 'ellipsis',
            overflow: 'hidden',
            whiteSpace: 'nowrap',
        },
    },
    [`& .${dropdownSlotClassNames.selectedItems}`]: {
        paddingRight: 0,
    },
    [`& .${dropdownSlotClassNames.itemsList}`]: {
        backgroundColor: theme.siteVariables.colors.primitive.white,
        maxWidth: pxToRem(492),
        boxShadow: `${pxArrayToRem([0, 14, 24, 2])} ${hex2rgba(
            theme.siteVariables.colors.primitive.black,
            0.08
        )}`,
    },
    [`& .${dropdownItemSlotClassNames.header}`]: {
        lineHeight: pxToRem(26),
        wordBreak: 'break-word',
    },
});

export const SingleValue: StyleRule = ({ theme }) => ({
    paddingLeft: pxToRem(55),
    fontSize: pxToRem(16),
    color: theme.siteVariables.colors.charcoal[250],
    letterSpacing: theme.siteVariables.letterSpacingMedium,
});
